
import { EventProvider } from "../providers/event/event";

export class LocationHandlerUtil {

    /**
     * 
     * @param lat 
     * the array with two points (the last one and the current one)
     * @param lng 
     * the array with two points (the last one and the current one)
     * @returns 
     * checks if there is a wierd behaviour of GPS location such as zig zag
     */
    static checkForZigZag(lat: number[], lng: number[]): boolean {
        return (Math.abs((lng[0] - lng[1])) > 0.003 || Math.abs(lat[0] - lat[1]) > 0.003) ? false : true;
    }

    /**
     * 

     * @param lat 
     * @param lng 
     * @returns the distance between two points in kms
     */
    static calcDistance(p1, p2) {
        var R = 6371.0710; // Radius of the Earth in miles
        var rlat1 = p1.lat() * (Math.PI / 180); // Convert degrees to radians
        var rlat2 = p2.lat() * (Math.PI / 180); // Convert degrees to radians
        var difflat = rlat2 - rlat1; // Radian difference (latitudes)
        var difflon = (p2.lng() - p1.lng()) * (Math.PI / 180); // Radian difference (longitudes)

        var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
        return d;
    }

    /**
     * 
     * @param array of points (lat, lng)
     * returns the distance of the path
     */
    static calcPathDistance(array) {
        let sum = 0;
        for (let i = 0; i < array.length - 1; i++) {
            sum += LocationHandlerUtil.calcDistance(array[i], array[i + 1]);
        }
        return sum.toFixed(2);
    }



    /**
     * 
     * @param c
     * indicates the current position of the person
     * @param o
     * indicates the starting point of the route
     * @param distance
     * indicates the distance to achive between points
     * @returns 
     * checks if the coords are in the area with the radius of 'distance' from 'origin'
     */
    static defDistance(coordinates, o, distance): boolean {

        if (!coordinates || !o) return false;

        let coords = {
            lat: coordinates.latitude || coordinates.lat,
            lng: coordinates.longitude || coordinates.lng
        };

        let origin = {
            lat: o.latitude || o.lat,
            lng: o.longitude || o.lng
        };

        const R = 6371e3; // metres
        const a1 = origin.lat * Math.PI / 180; // φ, λ in radians
        const a2 = coords.lat * Math.PI / 180;
        const b1 = (origin.lat - coords.lat) * Math.PI / 180;
        const b2 = (origin.lng - coords.lng) * Math.PI / 180;
        const a = Math.sin(b1 / 2) * Math.sin(b1 / 2) + Math.cos(a1) * Math.cos(a2) * Math.sin(b2 / 2) * Math.sin(b2 / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c; // in metres

        return (d < distance);
    }

    /**
     * 
     * @param distance 
     * the distane is measured in meters
     * @param duration 
     * the duration is measured in seconds
     * @returns
     * the current pace measured min per km (number)
     */
    static calcPace(distance, duration): string {
        if (distance <= 0) { return "0" };
        let sumDistance = distance;
        let dur = duration;
        let min = dur / 60;
        let km = sumDistance / 1000;
        let uncorrect = (min / km) + '';
        let result = Number(uncorrect).toFixed(2);
        uncorrect = result + "";
        let parts = uncorrect.split('.');

        if (typeof parts[1] != "undefined") {
            parts[1] = (parts[1].length == 1) ? parts[1] + "0" : parts[1];
            parts[1] = (Number(parts[1]) / 1.656) + "";
            parts[1] = parts[1].split('.')[0];

            let sec = parts[1];

            sec = (sec.length == 1) ? "0" + sec : sec;

            result = parts[0] + ":" + sec;
        }

        return (dur == 0) ? "0" : result;
    }

    /**
 * 
 * @param distance 
 * the distane is measured in meters
 * @param duration 
 * the duration is measured in seconds
 * @returns
 * the current pace measured min per milies (number)
 */
    static calcPaceMilie(distance, duration): string {
        if (distance <= 0) { return "0" };
        let sumDistance = distance;
        let dur = duration;
        let min = dur / 60;
        let km = sumDistance / 1000 * 0.621371;
        let uncorrect = (min / km) + '';
        let result = Number(uncorrect).toFixed(2);
        uncorrect = result + "";
        let parts = uncorrect.split('.');

        if (typeof parts[1] != "undefined") {
            parts[1] = (parts[1].length == 1) ? parts[1] + "0" : parts[1];
            parts[1] = (Number(parts[1]) / 1.656) + "";
            parts[1] = parts[1].split('.')[0];

            let sec = parts[1];

            sec = (sec.length == 1) ? "0" + sec : sec;

            result = parts[0] + ":" + sec;
        }

        return (dur == 0) ? "0" : result;
    }

    /**
     * 
     * @param competitors
     * array of tournament competitors
     * @param userResult
     * object of user results { time: number(seconds), distance: number(meters) }
     */
    static findNearestCompetitors(competitors, userResult) {
        let closestLeft,
            closestRight,
            secondsPerMeterCompetitor,
            secondsPerMetersUser = userResult.time / userResult.distance;


        let leftCompetitor = null;
        let rightCompetitor = null;

        let array = [];

        for (let i = 0; i < competitors.length; i++) {

            secondsPerMeterCompetitor = competitors[i].timeFormatted / competitors[i].strecke1;
            console.log('competitors.name : ' + competitors[i].athleteName);
            console.log('secondsPerMeterCompetitor: ' + secondsPerMeterCompetitor);
            console.log('secondsPerMetersUser: ' + secondsPerMetersUser);
            console.log("competitor.place" + competitors[i].place);

            if (secondsPerMeterCompetitor > secondsPerMetersUser && (typeof closestRight === 'undefined' || closestRight > secondsPerMeterCompetitor)) {
                closestRight = secondsPerMeterCompetitor;
                rightCompetitor = competitors[i];
                let difference = "+" + (-1 * (userResult.time - (userResult.distance * secondsPerMeterCompetitor))).toFixed(1);
                rightCompetitor.cid = difference;
                rightCompetitor.position = "left";
            }
            if (secondsPerMeterCompetitor < secondsPerMetersUser && (typeof closestLeft === 'undefined' || closestLeft < secondsPerMeterCompetitor)) {
                closestLeft = secondsPerMeterCompetitor;
                leftCompetitor = competitors[i];
                let difference = "-" + (userResult.time - (userResult.distance * secondsPerMeterCompetitor)).toFixed(1);
                leftCompetitor.cid = difference;
                leftCompetitor.position = "right";
            }
        }

        if (leftCompetitor) {
            array.push(leftCompetitor);
        }

        if (rightCompetitor) {
            array.push(rightCompetitor);
        }

        return array;
    }


    static assignAltitude(decodedPath, eventProvider: EventProvider, token) {
        return new Promise((resolve, reject) => {
            let index = 0;
            const allElevationPromises = []; // Array to hold all promises from getElevations

            const interval = setInterval(() => {
                if (index < decodedPath.length) {
                    let locations = "";
                    const locationsPerRequestLimit = 100;
                    for (let k = 0; k < locationsPerRequestLimit && index < decodedPath.length; k++) {
                        const latlng = decodedPath[index];
                        const coords = {
                            lat: latlng.lat(),
                            lng: latlng.lng()
                            // lat: typeof latlng.lat === "undefined" ? latlng[0] : latlng.lat,
                            // lng: typeof latlng.lng === "undefined" ? latlng[1] : latlng.lng,
                        };
                        locations = `${locations}${coords.lat}_${coords.lng}`;
                        if (k < locationsPerRequestLimit - 1 && index < decodedPath.length - 1) {
                            locations = `${locations}|`
                        }
                        index++;
                    }
                    const elevationPromise = eventProvider.getElevations(locations, token).then((res: any) => {
                        if (res.message) {
                            clearInterval(interval);
                            return;
                        }
                        return res; // You might want to do something with this result
                    }).catch(err => {
                        clearInterval(interval);
                        reject(err);
                    });
                    allElevationPromises.push(elevationPromise);
                } else {
                    clearInterval(interval); // Clear the interval when all coordinates have been processed
                    Promise.all(allElevationPromises).then((results) => {
                        resolve(results); // Resolve the main promise with the results of elevation promises
                    }).catch(reject); // In case any elevation promise is rejected
                }
            }, 300);
        })
        //return Promise.all(path.map((point) => eventProvider.getElevation(point.lat(), point.lng())));
    }

    fetchElevations(decodedPath, eventProvider, token) {

     
    }


    static assignAltitudeArr(path, eventProvider: EventProvider) {
        return Promise.all(path.map((point) => eventProvider.getElevation(point[0], point[1])));
    }

    /**
     * 
     * @param arr 
     * array of altitudes, the calculation works only for uphills, the downwards trend is ignored
     * @returns the sum up of all the upward altitudes
     */
    static calcAltitude(arr) {
        if (arr.length <= 0) return 0;

        var sums = 0;
        for (let i = 1; i < arr.length; i++) {
            if (arr[i] > arr[i - 1]) {
                sums += arr[i] - arr[i - 1];
            }
        }
        return sums;
    }


}